import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Loading from '@/components/Loading';

const PlainLayout = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Outlet />
    </Suspense>
  );
};

export default PlainLayout;
